export class ROUTE_CONSTANTS {
  static readonly home = '';
  static readonly formSubmitted = 'submitted';
  static readonly logout = 'logout';

  static readonly formResponse = {
    prefix: 'form-response',
    new: 'form-response/:applicationId/:templateId',
    edit: 'form-response/:id',
  } as const;
};
